<template>
  <div>
    <finances-report />
  </div>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

import FinancesReport from "../../../components/filtros/serviciosLogisticos/servicioIntegral/FinancesReport.vue";

export default {
  components: {
    FinancesReport
  },
  methods: {

    ...mapActions(["AccionCambiar"]),

    ...mapActions("lineas", [
      "actionSetDataListaNaviera",
      "actionSetDataListaCliente",
      "actionSetDataListaPOD",
      "actionSetDataListaNave"
    ]),

    actualizarURL() {

      let me = this;

      me.AccionCambiar(this.$route.path);

    }

  },

  created() {

    this.actualizarURL();

  }

};
</script>
<style></style>
